module.exports = __webpack_public_path__ + "img/ac6ffdf.png";